import type {
  MeetingDto,
  MeetingRequestTemplate,
} from "@shared/types/MeetingDto";
import type { ApiResponse } from "@shared/types/payloads/ApiResponse";
import type { CreateMeetingActionPayload } from "@shared/types/payloads/CreateMeetingActionPayload";
import type { CreateMeetingsRequestPayload } from "@shared/types/payloads/CreateMeetingsRequestPayload";
import type { MeetingsStatsResponse } from "@shared/types/payloads/MeetingsStatsResponse";
import type { MeetingsUpdatePayload } from "@shared/types/payloads/MeetingsUpdatePayload";
import { ApiService } from "./ApiService";

export class MeetingsService {
  constructor(private readonly apiService: ApiService) {}

  async getMeetings(): Promise<MeetingDto[]> {
    return this.apiService.request<MeetingDto[]>("/clients/meetings/list", {
      method: "GET",
      requireAuth: true,
    });
  }

  async getMeetingById(meetingId: string): Promise<MeetingDto> {
    return this.apiService.request<MeetingDto>(
      `/clients/meetings/${meetingId}`,
      {
        method: "GET",
        requireAuth: true,
      },
    );
  }

  async getStats(): Promise<MeetingsStatsResponse> {
    return this.apiService.request<MeetingsStatsResponse>(
      "/clients/meetings/stats",
      {
        method: "GET",
        requireAuth: true,
      },
    );
  }

  async getTemplates(): Promise<MeetingRequestTemplate[]> {
    return this.apiService.request<MeetingRequestTemplate[]>(
      "/clients/meetings/templates",
      {
        method: "GET",
        requireAuth: true,
      },
    );
  }

  async createMeeting(
    payload: CreateMeetingsRequestPayload,
  ): Promise<ApiResponse<MeetingDto>> {
    return this.apiService.request<ApiResponse<MeetingDto>>(
      "/clients/meetings",
      {
        method: "POST",
        body: JSON.stringify(payload),
        requireAuth: true,
      },
    );
  }

  async performAction(
    meetingId: string,
    payload: CreateMeetingActionPayload,
  ): Promise<ApiResponse<MeetingDto>> {
    return this.apiService.request<ApiResponse<MeetingDto>>(
      `/clients/meetings/${meetingId}/actions`,
      {
        method: "POST",
        body: JSON.stringify(payload),
        requireAuth: true,
      },
    );
  }

  async updateMeeting(
    meetingId: string,
    payload: MeetingsUpdatePayload,
  ): Promise<ApiResponse<MeetingDto>> {
    return this.apiService.request<ApiResponse<MeetingDto>>(
      `/clients/meetings/${meetingId}`,
      {
        method: "PATCH",
        body: JSON.stringify(payload),
        requireAuth: true,
      },
    );
  }
}
